import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import { FloatingLabel } from './FloatingLabel';
import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Validator } from './ValidationResult';
import { FormControl } from 'react-bootstrap';
import { withComponentCapabilities } from './capabilities/componentCapabilities';

export const customCtrlDef = {
    def: (t, tools) => ({
        form: [{
            borderless: true,
            rows: [
                ...tools.labelFields(t),
                ...tools.fieldFields(t),
                [
                    { type: "number", field: "min", label: t('min') },
                    { type: "number", field: "max", label: t('max') },
                    { type: "number", field: "step", label: t('step', { count: 1 }) },
                    {type: "checkbox", field: "showValue", label: t('showValue')}
                ],
                ...tools.commonFields(t)
            ]
        }]
    }),
    control: ({ def, href, ...props }) => <Range min={def.min} max={def.max} step={def.step} href={href ?? def.href} showValue={def.showValue} {...props}></Range>
}

const Range = withComponentCapabilities(({ value, min = 0, max = 100, step = 1, live = false, disabled = false, hideLabel = false, showValue = false, placeholder, onChange, href }) => {
    const [innerValue, setInnerValue] = useState(value);
    useEffect(() => setInnerValue(value), [value]);
    const [validity, setVaidity] = useState();
    const ctrlRef = useRef();

    useEffect(() => setVaidity(), [value]);

    const handleChange = (e) => {
        const valid = ctrlRef.current.checkValidity();
        setVaidity(valid);
        if (valid) {
            const newValue = parseFloat(e.target.value);
            setInnerValue(newValue);
            if (live && newValue !== value) {
                onChange(newValue);
            }
        }
    }

    const handleBlur = () => {
        if (innerValue !== value) {
            onChange(innerValue)
        }
    }

    const range = <div className="d-flex align-items-center justify-content-center"><FormControl required={true} isInvalid={validity === false} ref={ctrlRef} size="sm" value={innerValue} min={min} max={max} step={step} type="range" disabled={disabled} onChange={(newValue) => handleChange(newValue)} onBlur={() => handleBlur()}></FormControl><div className="pl-2">{showValue && innerValue}</div></div>

    return  <FloatingLabel placeholder={placeholder} value={value} hideLabel={hideLabel} href={href}>
                <Validator value={value} ref={ctrlRef} onValidation={setVaidity}>
                    {range}
                </Validator>
            </FloatingLabel>
}, {

});

Range.propTypes = {
    /**
     * The number to be displayed by the control
     */
    value: PropTypes.number,
    /**
     * Force the input to be read-only
     */
    disabled: PropTypes.bool,
    /**
     * Collapses the floating label used for spacing
     */
    hideLabel: PropTypes.bool,
    /**
     * The label for the control
     */
    showValue: PropTypes.bool,
    /**
     * An optional field label to be shown near the range control
     */
    placeholder: PropTypes.string,
    /**
     * The minimum value that can be selected
     */
    min: PropTypes.number,
    /**
     * The maximum value that can be selected
     */
    max: PropTypes.number,
    /**
     * The amount to increase or decrease value by when moving the slider.
     */
    step: PropTypes.number,
    /**
     * Function to call when the input value has been changed
     */
    onChange: PropTypes.func,
    /**
     * An option navigation URL to be followed if the label text is clicked
     */
    href: PropTypes.string,
}

export default Range;